import { doAjax } from './helper'
import { getInteriorImageForStoredComponent, getSteeringWheelCustomizedComponentImage } from './imagesLogicController'

/** Gets customized components for interior view and steering wheel from session. */
function loadAlreadyCustomizedOptions(callback = () => {}, options = {}) {
	doAjax({ 'get_customizable_options': true }, (response) => {
		addBaseLayers()
		loadCustomizedComponentsImages('car_interior', response)
		if (!options.skipSeatImages) {
			loadCustomizedComponentsImages('car_frontseat', response)
			loadCustomizedComponentsImages('car_backseat', response)
		}
		loadCustomizedComponentsImages('steering_wheel', response)
		callback()
	})
}


/** Adds conditional layers such as different steering wheels or rs badges */
function addBaseLayers(){
	
	let imgSource = "";
	const carmodel = document.getElementsByName('carmodel')[0].value
	const steeringwheelmodel = document.getElementsByName('steering-wheel-model')[0].value
	//IF HOUR MARK STEERING WHEEL
	if (aeo['configuration']['YVN'] == true || aeo['configuration']['YVN_without12h'] == true || aeo['configuration']['0UD_RS5'] == true || aeo['configuration']['0UD_SQ6_perf'] == true || aeo['configuration']['0UQ_SQ6_perf'] == true) {
		//SET HOUR_MARK STEERING WHEEL AS INTERIOR OVERLAY 
		if (carmodel == 1) {
				imgSource = 'img/01_interieur/yvu-yvn_lenkrad/lenkrad_yvn_1xy_12uhr/au513_e-tron_gt_lenkrad_yve_1xy_schwarz_basis.png' 
			} else if (carmodel == 46 || carmodel == 47) {
				if (steeringwheelmodel == 73) {
						imgSource = 'img/01_interieur/au401_rs5_lenkraeder/au401_rs5_2zc_6f6_lenkrad_12_uhr/au401_rs5_2zc_6f6_0ud_schwarz_basis.png' 
					} else {
						imgSource = 'img/01_interieur/au401_rs5_lenkraeder/au401_rs5_2zc_6f8_lenkrad_12_uhr/au401_rs5_2zc_6f8_0ud_schwarz_basis.png'  
					} 
			} else if (carmodel == 70 || carmodel == 71) {
				if (steeringwheelmodel == 63) {
						imgSource = 'img/01_interieur/au41x_q6_etron_sport_2zc_6f6_lenkrad_12_uhr/au41x_q6_etron_2zc_6f6_0ud_schwarz_basis.png' 
					} else {
						imgSource = 'img/01_interieur/au41x_q6_etron_sport_2zc_6f9_lenkrad_12_uhr/au41x_q6_etron_2zc_6f9_0uq_schwarz_basis.png'  
					} 		
			} else {
				imgSource = 'img/01_interieur/yvu-yvn_lenkrad/lenkrad_yvn_2zc_12uhr/au513_e-tron_gt_lenkrad_yve_2zc_schwarz_basis.png' 
			}
		replaceImage(imgSource, 'hour-mark-steering-wheel-component', 'car_frontseat')

		//SET HOUR MARK STEERING WHEEL BASE 
		/*
		if (carmodel == 1) {
			imgSource = 'img/04_lenkrad/au513_e-tron_gt_yvn_1xy_12_uhr_markierung_lenkrad/au513_e-tron_gt_12-uhr-lenkrad_yvn_1xy_schwarz_basis.png'
		} else { // e-tron Performance ID?!?
			imgSource = 'img/04_lenkrad/au513_e-tron_gt_yvn_2zc_12_uhr_markierung_lenkrad/au513_e-tron_gt_12-uhr-lenkrad_yvn_2zc_schwarz_basis.png'
		}
		replaceImage(imgSource, 'steering-wheel-base', 'steering_wheel')
		*/
	}

	// IF BICOLOR-DESIGN
	if (aeo['configuration']['YVE'] == true) {
		//SET ALCANTARA STEERING WHEEL BASE 
		//imgSource = 'img/04_lenkrad/12-uhr-lenkrad_yve_1xw-2pf/au513_e-tron_gt_12-uhr-lenkrad_yve_1xw-2pf_schwarz_0001_lenkrad.png'
		replaceImage(imgSource, 'steering-wheel-base', 'steering_wheel')
	}
	if (aeo['configuration']['YVE_RS6RS7'] == true) {
		//SET ALCANTARA STEERING WHEEL BASE 
		imgSource = 'img/04_lenkrad/rs6-rs7_sportkontor-lenkrad_2pz_yvq/au58x_rs6-rs7_sportkontor_2pz_3_speichen_lenkrad_schalthebel_alcantara_basis.png'
		replaceImage(imgSource, 'steering-wheel-base', 'steering_wheel')
	}

	//IF RS MODEL
	const isCarRsModel = document.querySelector("input[name='is-car-rs-model']").value
	if (isCarRsModel) {
		//ADD SEATS AND STEERING WHEEL INTERIOR BADGES
		//imgSource = 'img/01_interieur/paketauswahl/au513_e-tron_gt_paketauswahl_rs_badges_zierleiste.png'
		//replaceImage(imgSource, 'seat-badge', 'car_frontseat')

		//ADD STEERING WHEEL RS BADGE
		//imgSource = 'img/04_lenkrad/lenkrad_yrb_1xp_2pf/rs_badge/au513_e-tron_gt_lenkrad_yrb_1xp_2pf_rs_badge.png'
		//replaceImage(imgSource, 'rs-badge', 'steering_wheel')
	}

	//IF RS FOOTMAT
	if (aeo['configuration']['YTU'] == true) {
		//ADD FOOTMAT RS BADGE
		//imgSource = 'img/01_interieur/paketauswahl/au513_e-tron_gt_paketauswahl_rs_badges_zierleiste_fussmatte.png'
		//replaceImage(imgSource, 'rs-footmat-badge', 'car_frontseat')
	}
	
}

function loadCustomizedComponentsImages(componentType, response) {
	
	if (componentType in response) {
		for (const key in response[componentType]) {
			if (key.indexOf('Color') != -1) {
				if (Object.hasOwnProperty.call(response[componentType], key)) {
					let element = response[componentType][key];
					let unfilteredComponent = key;
					let frontseatmodel = document.getElementsByName("frontseatmodel")[0].value
					let backseatmodel = document.getElementsByName("backseatmodel")[0].value
					let seatComponentSelection = document.querySelector("input[name=seatcomponentselection]").value;
					if(componentType == 'car_frontseat') {
						if(aeo['components']['configuration_'+frontseatmodel].indexOf(key) == -1) {
							unfilteredComponent = ''
						}
					}
				
					if(componentType == 'car_backseat') {
						if(aeo['components']['configuration_'+frontseatmodel+'_'+backseatmodel].indexOf(key) == -1) {
							unfilteredComponent = ''
						}
					}
				
					let component = "";
					let colorCode = element.toString();
					
					if (colorCode != "") {
						//filter component names
						if (unfilteredComponent.indexOf('PressedColor') != -1) {
							component = unfilteredComponent.replace('PressedColor', '')
						} else if (unfilteredComponent.indexOf('PressedStitchColor') != -1) {
							component = unfilteredComponent.replace('PressedStitchColor', '')
						} else {
							component = unfilteredComponent
						}

						if (
							componentType == 'steering_wheel'
							&& component == 'bottomColor'
							&& aeo['configuration']['YVQ_etronGT'] == true
							&& response[componentType]['topColor']
						) {
							colorCode = response[componentType]['topColor'].toString();
						}

						//replace image on interior
						let images = getInteriorImageForStoredComponent(componentType, component, colorCode)
						
						for (const jsonkey in images) {
							
							if (Object.hasOwnProperty.call(images, jsonkey)) {
								const imgSrc = images[jsonkey];
								if (imgSrc != "") {
									if ((componentType == 'car_frontseat' || componentType == 'car_backseat') && document.forms[0].elements.namedItem("pdf")){
										if(componentType == 'car_frontseat') {
											var seatType = 'frontSeat'
										} else {
											var seatType = 'backSeat'
										}
										replaceImageSeatComponent(seatType, component, colorCode, frontseatmodel, backseatmodel, seatComponentSelection) 
									}
									if (jsonkey == 'front_interior_image_back') {
										var componentId = 'car_backseat';
										component = component+'-1'
									} else {
										var componentId = componentType == 'car_frontseat' || componentType == 'steering_wheel' || jsonkey == "front_interior_image" ? 'car_frontseat' : 'car_backseat'
										
									}
									replaceImage(imgSrc, component, componentId)
								}
							}
						}
						
						//replace image on big steering wheel screen
						if (componentType == 'steering_wheel') {

							const filteredComponent = component.replace('Color', '');
							let imgSrc = getSteeringWheelCustomizedComponentImage(filteredComponent, colorCode)
							if (colorCode == "8" && filteredComponent == "top") imgSrc = "" //quickfix since we dont have the black image
							if ((colorCode == "11" || colorCode == "0") && filteredComponent == "hourMark") imgSrc = "" //quickfix since we dont have the black image
							if (colorCode == "8" && filteredComponent == "stitchHourMark") imgSrc = "" //quickfix since we dont have the black image
							if (colorCode == "8" && filteredComponent == "AirbagCoverLeather") imgSrc = "" //quickfix since we dont have the black image
							if (colorCode == "8" && filteredComponent == "AirbagCoverStitches") imgSrc = "" //quickfix since we dont have the black image
							if (colorCode == "8" && filteredComponent == "AirbagCoverStitchesColor") imgSrc = "" //quickfix since we dont have the black image
							if (colorCode == "8" && filteredComponent == "GearLeverStitches") imgSrc = "" //quickfix since we dont have the black image
							if (colorCode == "8" && filteredComponent == "stitches_A6A7") imgSrc = "" //quickfix since we dont have the black image
							if (colorCode == "8" && filteredComponent == "stitchesColor_A6A7") imgSrc = "" //quickfix since we dont have the black image

							if (imgSrc != "") {
								if (
									aeo['configuration']['0UD_SQ6_perf'] == false ||
									aeo['configuration']['0UQ_SQ6_perf'] == false ||
									aeo['configuration']['0UD_RS5'] == false ||
									aeo['configuration']['YVN'] == false ||
									aeo['configuration']['YVN_without12h'] == false ||
									['hourMark', 'stitchHourMark', 'top'].indexOf(filteredComponent) != -1
								) {
									replaceImage(imgSrc, filteredComponent, componentType)
								}
							}
						}
					}
				}
			}
		}
	}
}

function replaceImage(imageSource, component, componentId = "") {
	let isStitchingPackage = aeo['configuration']['YVJ'] == true
if (componentId == 'car_frontseat' && isStitchingPackage && ['pipingColor', 'stitchPipingColor', 'stitchColor', 'stitchesColor', 'stitchesColor_A6A7', 'hourMarkColor', 'stitchHourMarkColor', 'GearLeverStitches', 'GearLeverStitchesColor', 'GearLever', 'GearLeverColor','AirbagCoverLeather','AirbagCoverStitches','sky','bicolor'].indexOf(component) != -1) return;

	let imageBaseId = ""
	if (componentId == 'car_backseat') imageBaseId =  'interior-backview'
	if (componentId == 'car_frontseat') imageBaseId =  'interior-frontview'
	if (componentId == 'steering_wheel') imageBaseId =  'steering-wheel'
	if (componentId == 'steering_wheel_1') imageBaseId =  'steering-wheel'

	// Q9 (118) / SQ9 (119): alle Backview-Overlays nutzen den au616-Ordner (Dateiname bleibt au546_...)
	if (imageBaseId == 'interior-backview' && typeof imageSource === 'string') {
		const carModelBackview = (document.querySelector("input[name=carmodel]") || {}).value
		if (carModelBackview == 118 || carModelBackview == 119 || carModelBackview == 120) {
			imageSource = imageSource.replace('02_interieur_backview/au546_', '02_interieur_backview/au616_')
		}
	}

	let query = "#"+imageBaseId+" img.overlay"
	let imageArray = document.querySelectorAll(query);

	if(imageArray.length == 0) return;

	//if image exists, modify src

	const imageId = component + '-img'
	let imageExists = false;
	imageArray.forEach(element => {
		if (element.id != null && element.id == imageId) {
			imageExists = true
			element.src = imageSource
		}
	});
	//if image does not exist, create it
	if (!imageExists) {
		let newImage = document.createElement('IMG')
		newImage.classList.add('overlay')
		newImage.id = component + '-img'
		imageArray[imageArray.length-1].insertAdjacentElement('afterend', newImage)
		if(imageSource && !imageSource.includes("undefined")) newImage.src = imageSource
		//newImage.src = imageSource
	}
}


function replaceImageSeatComponent(seatType, component, colorCode, frontSeatModel, backSeatModel, seatComponentSelection) {
	//console.log(seatType+' - '+component+' - '+colorCode+' - '+frontSeatModel+' - '+backSeatModel+' - '+seatComponentSelection)
	const thirdSeatRow = document.querySelector("input[name=thirdseatrow]").value;
	const q1dembossing = document.querySelector("input[name=q1dembossing]").value;
	const modelcategory = document.querySelector("input[name=modelcategory]").value;
	let thirdRowComponents = ['q7_g8', 'q9_g8'].includes(modelcategory)
		? ['headrestFront','headrestSide','seatCenterPanel','headrestStitching','contrastStitchingSide','contrastStitchingHoneycombQuilting','contrastStitchingDiamondQuilting','contrastStitchingCenter']
		: ['headrestSide', 'headrestFront','contrastStitchingSide','thighPad',
		'bolstersOutside','shoulderArch','seatSideBolstersInside','seatCenterPanel2',
		'seatSportStripe','circumferentialBand'];
	if (seatType == 'backSeat' && thirdSeatRow && thirdRowComponents.includes(component)) {
		replaceImageSeatComponent('thirdSeatRow', component, colorCode, frontSeatModel, backSeatModel, seatComponentSelection)
	}
	// fake select no component in backseat
	if (seatType == 'thirdSeatRow' && frontSeatModel == 'Q4Q_AU53X' && component == 'seatCenterPanel2') {
		replaceImageSeatComponent('thirdSeatRow', 'seatSportStripe', colorCode, frontSeatModel, backSeatModel, seatComponentSelection)
	}
	var element_id = ''
	var element_class = ''
	var seatarrayname = ''
	if (seatType == 'frontSeat') {
		element_id = 'seat-single'
		element_class = '.wrapper-relative img.overlay'
		seatarrayname = 'frontseat_'+frontSeatModel+'_component_path'
		if(modelcategory != 'a8' && ( component == 'seatCover' || component == 'contrastStitchingSeatCover' ) ) {
			seatarrayname = 'frontseat_'+frontSeatModel+'_YQN_component_path'
		}
	} else if (seatType == 'backSeat') {
		element_id = 'backseat'
		element_class = '.wrapper-relative img.overlay'
		seatarrayname = 'backseat_'+frontSeatModel+'_'+backSeatModel+'_component_path'
		if(modelcategory == 'a8' && ( component == 'headrestPillow' || component == 'extraPillow' || component == 'audiRingsStiching' ) ) {
			seatarrayname = 'backseat_YXK_component_path'
		}
	} else { // third seat row
		element_id = 'third-row'
		element_class = '.wrapper-relative-third-row img.overlay'
		seatarrayname = ['q7_g8', 'q9_g8'].includes(modelcategory) ? 'thirdseatrow_q7_g8_component_path' : 'thirdseatrow_q7_component_path'
	}
	if ((component.indexOf('-1') == -1) && colorCode != undefined) {
		var componentPictureName = aeo['components']['seat_components_screen'+seatComponentSelection][component] + '.png';
		var slineApplies = q1dembossing && (component == 'backrestTop' || component == 'headrestFront') && modelcategory != 'a8' && seatType != 'thirdSeatRow';
		if (slineApplies && component == 'headrestFront' && seatType == 'backSeat' && backSeatModel.indexOf('5KI') === -1) {
			slineApplies = false; // 5KA_5KL hat keine _s-Variante für headrestFront
		}
		var embossingVariant = aeo['components']['seat_components_screen'+seatComponentSelection+q1dembossing];
		if (slineApplies && (!embossingVariant || embossingVariant[component] === undefined)) {
			slineApplies = false; // z.B. _embossing_rsline hat kein eigenes headrestFront-Bild -> Standardbild verwenden
		}
		if(slineApplies) {
			componentPictureName = aeo['components']['seat_components_screen'+seatComponentSelection+q1dembossing][component] + '.png';
		}
		
		if(q1dembossing && component == 'shoulderArch' && modelcategory == 'a8') { // only A8
			if (seatType == 'frontSeat') {
				componentPictureName = aeo['components']['seat_components_screen'+seatComponentSelection+q1dembossing+'_A8'][component] + '.png';
			}
		}
		//const imageSource = aeo['paths'][seatType == 'frontSeat' ? 'frontseat_'+frontSeatModel+'_component_path' : 'backseat_'+frontSeatModel+'_'+backSeatModel+'_component_path'][colorCode] + componentPictureName
		const imageSource = aeo['paths'][seatarrayname][colorCode] + componentPictureName
		
		//let imageArray = document.getElementById(seatType == 'frontSeat' ? 'seat-single' : 'backseat').querySelectorAll('.wrapper-relative img.overlay')
		let imageArray = document.getElementById(element_id).querySelectorAll(element_class)
		const imageId = component + '-img'
		let imageExists = false;
		imageArray.forEach(element => {
			if (element.id != null && element.id == imageId) {
				imageExists = true
				element.src = imageSource
			}
		});
		if (!imageExists && imageArray.length > 0) {
			let newImage = document.createElement('IMG')
			newImage.classList.add('overlay')
			newImage.id = component + '-img'
			imageArray[imageArray.length - 1].insertAdjacentElement('afterend', newImage)
			newImage.src = imageSource
		}
	}
	
}

export { loadAlreadyCustomizedOptions, replaceImage }
